import { Component, OnInit } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService } from '../../services'
import { Depot } from 'depoto-core/src/entities'
import { depotsColumns } from '../../utils/definitions.util'
import { SchemaUtil } from '../../utils'

const DEFAULT_FILTERS = {
  visible: false,
  expanded: false,
  name: '',
  sortProp: 'name',
  sortDir: 'asc',
}

@Component({
  selector: 'app-depots',
  templateUrl: './depots.component.html',
})
export class DepotsComponent extends BaseListing implements OnInit {
  listingColumns: ListingItem[] = depotsColumns
  depots: Depot[] = []
  totalItems = 0
  currentPage: number
  endPage: number
  filters = DEFAULT_FILTERS
  canCreate = false
  loading = true

  constructor(protected core: CoreService) {
    super(core)
    this.getStorageKey('depots')
    this.checkPerms()
  }

  async ngOnInit() {
    this.filters = this.loadViewSettings('depots') || DEFAULT_FILTERS
    await this.filter(1)
  }

  checkPerms() {
    this.canCreate =
      this.core.services.user.hasRole('ROLE_DEPOT_CREATE') ||
      this.core.services.user.hasRole('ROLE_SUPER_ADMIN') ||
      this.core.services.user.hasRole('ROLE_ADMIN')
  }

  clearFilters() {
    this.filters.name = ''
    this.filter(1)
  }

  async filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false) {
    this.loading = true
    this.currentPage = pageNo
    if (!concat) {
      this.reloading = true
    }

    const result = await this.core.services.depot.getList(
      {
        page: pageNo,
        sort: sortProp,
        direction: sortDir,
        filters: { name: this.filters.name },
      },
      SchemaUtil.depot,
    )
    concat
      ? result?.items?.forEach(depot => {
          this.depots.push(new Depot(depot))
        })
      : (this.depots = result?.items || [])
    this.depots = this.depots.filter(depot => {
      return depot.name !== 'all' && this.core.services.user?.user?.depots?.some(d => d.id === depot.id)
    })
    this.totalItems = result?.paginator ? result.paginator.totalCount : 0
    this.endPage = result?.paginator ? result.paginator.endPage : 0

    this.loading = false
    this.reloading = false
    this.saveViewSettings('depots', this.filters)
  }

  openUrl(entity: Depot): void {
    window.open(entity.unavailablesUrl)
  }
}
